var OVERLAY = require(/*! ./game-overlay.js */"./game-overlay.js");

// CTXT:
var context = module.exports;
context.active = true;
context.menu2 = "rcY";
var showSpectate = true;

// TOGGLE MENU:
context.toggleMenu = function (visible) {
  menuHolder.style.display = visible ? "block" : "none";
  speakerDisplay.style.display = visible ? "none" : "block";
  chatHolder.style.bottom = (visible ? 20 : 140) + "px";
  voiceDisplay.style.bottom = (visible ? 18 : 135) + "px";
  context.toggleMenuHider(visible);
  if (visible) {
    endUI.style.display = "none";
    instructionHolder.style.display = "block";
    // menuClassContainer.style.display = null;
    if (windowHolder.style.display != "block") {
      baseLinks.style.display = "block";
    }
  }
  context.active = true;
};

// HIDE UI:
context.hideUI = function () {
  context.toggleMenu(false);
  inGameUI.style.display = "none";
  spectateUI.style.display = "none";
  aimRecticle.style.display = "none";
  instructionHolder.style.display = "none";
  // menuClassContainer.style.display = "none";
  baseLinks.style.display = "none";
  chatHolder.style.bottom = "20px";
  voiceDisplay.style.bottom = "18px";
  speakerDisplay.style.right = "20px";
  purchaseHolder.style.display = "none";
  consentBlock.style.display = "none";
  context.active = false;
};

// HIDE ON DISCONNECT:
context.hideDiscon = function () {
  chatHolder.style.display = "none";
  voiceDisplay.style.display = "none";
  speakerDisplay.style.display = "none";
  purchaseHolder.style.display = "none";
};

// SHOW END SCREEN:
context.showEndScreen = function () {
  endTable.style.display = "none";
  voteHolder.style.display = "none";
  endUI.style.display = null;
  context.hideUI();
};

// TOGGLE MENU WINDOW:
context.toggleWindow = function (visible, controller) {
  windowHolder.style.display = visible ? "block" : "none";
  baseLinks.style.display = visible ? "none" : "block";
  instructions.innerHTML = visible ? "" : controller ? "PRESS START" : "CLICK TO PLAY";
  // menuClassContainer.style.display = visible?"none":null;
};

// TOGGLE MENU HIDER:
context.toggleMenuHider = function (visible) {
  menuHider.style.display = visible ? "block" : "none";
  uiBase.classList.toggle("onMenu", visible);
  gameNameHolder.style.display = visible ? null : "none";
  spectButton.style.display = showSpectate && visible ? null : "none";
  if (visible) {
    spinUI.style.display = "none";
  }
};

/// SET SHOW SPECTATE:
context.setShowSpect = function (visible) {
  showSpectate = visible;
  spectButton.style.display = visible ? null : "none";
};

// SHOW TEAM SELECTOR:
context.setShowSelTeam = function (visible) {
  teamSelector.style.display = visible ? "block" : "none";
};

// SHOW ERROR:
context.showError = function (text) {
  context.toggleMenu(true);
  instructions.innerHTML = text;
};

// TOGGLE GAME UI:
context.toggleGameUI = function (visible) {
  var sVis = visible && !window.spectating;
  spectateUI.style.display = window.spectating && visible ? "block" : "none";
  gameMessage.style.display = sVis ? "block" : "none";
  topLeftHolder.style.display = sVis ? "block" : "none";
  topRight.style.display = visible ? "block" : "none";
  reloadMsg.style.display = sVis ? "block" : "none";
  healthHolder.style.display = sVis ? "block" : "none";
  weaponDisplay.style.display = sVis ? "block" : "none";
  bottomRight.style.display = sVis ? "block" : "none";
  killCardHolder.style.display = visible ? "none" : "block";
  speakerDisplay.style.right = (!visible ? 20 : 380) + "px";
  chatHolder.style.bottom = (!sVis ? 20 : 140) + "px";
  voiceDisplay.style.bottom = (!sVis ? 18 : 135) + "px";
};

// TOGGLE CONTROLS:
context.toggleControlUI = function (visible) {
  if (window.loading) {
    visible = false;
  }
  spectateUI.style.display = window.spectating && visible && !context.hideGameUI ? "block" : "none";
  inGameUI.style.display = visible && context.active && !context.hideGameUI ? "block" : "none";
  aimRecticle.style.display = visible && context.active ? "block" : "none";
  instructionHolder.style.display = !visible && context.active ? "block" : "none";
  // menuClassContainer.style.display = (!visible&&context.active)?null:"none";
  aHolder.style.display = !visible ? "block" : "none";
  toggleAd(!visible);
  infoHolder.style.display = !visible ? null : "none";
  chatHolder.style.bottom = (visible && !window.spectating && healthHolder.style.display == "block" ? 140 : 20) + "px";
  voiceDisplay.style.bottom = (visible && !window.spectating && healthHolder.style.display == "block" ? 135 : 18) + "px";
  speakerDisplay.style.display = visible && context.active ? "block" : "none";
  if (endUI.style.display) {
    menuHolder.style.display = visible ? "none" : "block";
    context.toggleMenuHider(!visible);
  }
};

// SCALE CROSSHAIR:
var lastScale = 0;
var lastOpacity = 0;
context.updateCrosshair = function (scale, opacity) {
  OVERLAY.crosshairOpacity = opacity;
  OVERLAY.crosshairScale = scale;
};